import { useRef, useState } from 'react';
import screenfull from 'screenfull';
import { sendAnalyticsEvent } from 'src/lib/googleAnalytics';
import { t } from 'src/lib/player/i18n';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { useEventListener } from 'usehooks-ts';
import { IconCompress, IconExpand } from '../../BasicComponents/Icons';

export default function FullscreenControl(): JSX.Element {
  const [isFullscreen, setIsFullscreen] = useState(screenfull.isEnabled && screenfull.isFullscreen);
  const documentRef = useRef<Document>(document);

  function handleFullscreenChange() {
    setIsFullscreen(screenfull.isFullscreen);
  }

  // screenfull.raw resolves the vendor-prefixed names on older engines, so these
  // are runtime strings rather than the literal keys the hook expects.
  useEventListener(
    screenfull.raw.fullscreenchange as keyof DocumentEventMap,
    handleFullscreenChange,
    documentRef,
  );
  useEventListener(
    screenfull.raw.fullscreenerror as keyof DocumentEventMap,
    handleFullscreenChange,
    documentRef,
  );

  async function handleClick() {
    sendAnalyticsEvent('fullscreen-click');
    await screenfull.toggle(document.body);
    setIsFullscreen(screenfull.isFullscreen);
  }

  return (
    <div className="mapboxgl-ctrl-group">
      <button
        className="mapboxgl-ctrl-icon"
        title={t('Fullscreen')}
        {...onClickGenerator(handleClick)}
      >
        {isFullscreen ? <IconCompress /> : <IconExpand />}
      </button>
    </div>
  );
}
